import { Controller } from "@hotwired/stimulus"

// Controller for elements that require authentication
// Usage: data-controller="auth-required" data-auth-required-action-value="like" data-auth-required-url-value="/posts/1/vote"

export default class extends Controller {
  static values = {
    action: { type: String, default: 'default' },
    url: String,
    method: { type: String, default: 'POST' },
    signedIn: { type: Boolean, default: false }
  }
  
  connect() {
    // Check if user is signed in by looking for a meta tag or data attribute
    this.signedInValue = document.body.dataset.userSignedIn === 'true'
  }
  
  // Intercept click and show auth modal if not signed in
  perform(event) {
    if (this.signedInValue) {
      // User is signed in, let the action proceed normally
      return true
    }
    
    // Prevent default action
    event.preventDefault()
    event.stopPropagation()
    
    // Open auth modal with pending action
    const url = this.urlValue || this.element.href || this.element.dataset.url
    const method = this.methodValue || this.element.dataset.method || 'POST'
    
    if (window.openAuthModal) {
      window.openAuthModal(this.actionValue, url, method)
    } else {
      // Fallback: redirect to sign in
      window.location.href = '/users/sign_in'
    }
    
    return false
  }
}
